/**
 * Home icon for sidebar navigation (Figma design).
 */

import React from "react";
import type { IconProps } from "./types";

const HomeIcon: React.FC<IconProps> = ({
  size = 20,
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.08 7.513V2M17.82 7.656v8.696A1.65 1.65 0 0116.173 18h-2.108a1.65 1.65 0 01-1.648-1.648v-2.408a1.65 1.65 0 00-1.649-1.648H9.232a1.65 1.65 0 00-1.648 1.649v2.407A1.65 1.65 0 015.935 18H3.827a1.65 1.65 0 01-1.648-1.648V8.545c0-.555.279-1.072.744-1.378l6.175-4.044c.55-.36 1.26-.36 1.809 0l4.175 2.736"
      stroke={color}
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HomeIcon;
